var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.effectName } }, [
    _vm.show
      ? _c(
          "div",
          { class: _vm.classObject },
          [
            _c("span", [_vm._t("default")], 2),
            _vm._v(" "),
            _c("close-button", {
              attrs: { action: "" },
              domProps: { innerHTML: _vm._s(_vm.closeHtml) },
              on: { close: _vm.onClose }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }